const e = "service_OArQF", t = "title_Pzf27", s = "image_Zy78l", i = {
  service: e,
  title: t,
  image: s
};
export {
  i as default,
  s as image,
  e as service,
  t as title
};
//# sourceMappingURL=kioskService.module.scss.js.map
